import { Box, Text } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { ReactElement, FC, PropsWithChildren } from 'react';

import type { ERROR_MESSAGE_TYPE } from '../ActionableFormView';

import * as styles from './StickyButtonsFormView.css';

export interface StickyButtonFormViewProps {
  isStickyButtons: boolean;
  errorMessage?: ERROR_MESSAGE_TYPE;
  footerElement?: ReactElement;
  buttons: ReactElement;
}

export const StickyButtonsFormView: FC<
  PropsWithChildren<StickyButtonFormViewProps>
> = observer(
  ({ isStickyButtons, errorMessage, buttons, footerElement, children }) => {
    const hasErrorMessage = errorMessage && errorMessage !== '';

    return (
      <>
        {isStickyButtons ? (
          <Box
            paddingBottom={
              hasErrorMessage && footerElement ? 'xxlarge' : 'none'
            }
            marginBottom="large"
          >
            {children}
          </Box>
        ) : (
          children
        )}
        <Box className={{ [styles.stickyButtons]: isStickyButtons }}>
          {hasErrorMessage && (
            <Box padding="small">
              <Text tone="critical">{errorMessage}</Text>
            </Box>
          )}
          <Box display="flex" justifyContent="spaceBetween" alignItems="center">
            {footerElement && <>{footerElement}</>}
            <Box width="full">{buttons}</Box>
          </Box>
        </Box>
      </>
    );
  },
);
